import { styled, Typography, Button as ButtonBase } from '@mui/material';
import { withDefaults } from '../../utils/withDefaults';
import { spreadTypography } from '../../utils/typeUtils';
const ButtonRoot = styled(ButtonBase)({
  maxWidth: 374,
  width: '100%'
});
export const Button = withDefaults(ButtonRoot, {
  size: 'lg'
});
export const Root = styled('section', {
  shouldForwardProp: prop => prop !== 'compact'
})(({
  theme,
  compact
}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: 552,
  margin: 'auto',
  textAlign: 'center',
  ...(!compact && {
    paddingTop: theme.spacing(4)
  })
}));
export const Title = styled(Typography, {
  shouldForwardProp: prop => prop !== 'compact'
})(({
  theme,
  compact
}) => ({
  display: 'block',
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(compact ? 3 : 4),
  ...spreadTypography(theme.typography[compact ? 'DM Serif H3' : 'DM Serif H2'])
}));
export const Message = styled(Typography, {
  shouldForwardProp: prop => prop !== 'compact'
})(({
  theme,
  compact
}) => ({
  marginBottom: theme.spacing(compact ? 3 : 4),
  color: theme.palette.grey[700],
  ...spreadTypography(theme.typography[compact ? 'Lato Body 1' : 'Lato H5']),
  '> a': {
    color: theme.palette.primary.main,
    ...spreadTypography(theme.typography[compact ? 'Lato Link 1' : 'Lato H5 Bold'])
  }
}));
export const NextSteps = styled(Typography, {
  shouldForwardProp: prop => prop !== 'compact'
})(({
  theme,
  compact
}) => ({
  marginTop: theme.spacing(compact ? 3 : 4),
  color: theme.palette.grey[700],
  ...spreadTypography(theme.typography[compact ? 'Lato Body 2' : 'Lato Body 1']),
  a: {
    color: theme.palette.primary.main,
    ...spreadTypography(theme.typography[compact ? 'Lato Link 2' : 'Lato Link 1'])
  }
}));